import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

import Timeline from './Timeline';
import Step1 from './Step1';
import Step2 from './Step2';
import persistor from '../../../helpers/Persistor';
import Step3 from './Step3';
import { useRouter } from '../../../hooks';
import HeaderMeta from '../../../components/HeaderMeta';

const B2BForm = ({ handleSubmit }) => {
  const { lang, countryEmoIso2 } = useRouter();
  const [activeStep, setActiveStep] = useState(1);

  const saveData = (data, actions) => {
    persistor.persist('contact_form', { ...persistor.get('contact_form'), ...data });
    actions.setSubmitting(false);
  };

  const handleStep = (increment) => {
    setActiveStep(activeStep + increment);
    window.scrollTo(0, 0);
  };

  const formatData = ({ rgpd, conditions, civility, testUsages, products, ...data }) => {
    return {
      contactType: 'organisation',
      preferredLanguage: lang.toUpperCase(),
      country: countryEmoIso2,
      civility: parseInt(civility),
      ...data,
    };
  };

  return (
    <Fragment>
      <HeaderMeta page={'contact-pro'} />
      <Timeline activeStep={activeStep} goToStep={setActiveStep} />
      <h2 className="contact-form__step-title">
        <Trans>{`contact.professional.timeline.step-${activeStep}`}</Trans>
      </h2>

      {activeStep === 1 && (
        <Step1
          initialValues={persistor.get('contact_form')}
          onSubmit={(data, actions) => {
            saveData(data, actions);
            handleStep(1);
          }}
        />
      )}

      {activeStep === 2 && (
        <Step2
          initialValues={persistor.get('contact_form')}
          onSubmit={(data, actions) => {
            saveData(data, actions);
            handleStep(1);
          }}
          onCancel={() => handleStep(-1)}
        />
      )}

      {activeStep === 3 && (
        <Step3
          initialValues={persistor.get('contact_form')}
          onSubmit={(data, actions) => {
            saveData(data, actions);
            handleSubmit(formatData(persistor.get('contact_form')));
          }}
          onCancel={() => handleStep(-1)}
        />
      )}
    </Fragment>
  );
};

B2BForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
};

B2BForm.defaultProps = {
  handleSubmit: () => {},
};

export default B2BForm;
